import axios from 'axios';
import { getToken } from 'frontend/utils/csrf';
import { appendGetParams } from 'frontend/utils/urls';

import { getServerSideContext } from 'frontend/utils/ssr-context';
import { safeWindow } from 'frontend/utils/window';

const getRequestHeaders = () => {
  const headers = {
    'X-CSRFToken': getToken(),
    'X-Requested-With': 'XMLHttpRequest',
  };
  if (safeWindow() === undefined) {
    return {
      ...headers,
      'User-Agent': '__ssr_request__',
    };
  }
  return headers;
};

export function getData(url: string = ''): Promise<any> {
  const config = {
    method: 'GET',
    headers: getRequestHeaders(),
  };

  return axios
    .get(url, config)
    .then((response: any) => response.data)
    .catch((error: Error) => {
      // tslint:disable-next-line:no-console
      console.log(error);
      throw error;
    });
}

export function postData(url: string = '', data: any = {}): Promise<any> {
  const config = {
    method: 'POST',
    headers: getRequestHeaders(),
  };

  return axios
    .post(url, data, config)
    .then((response: any) => response.data)
    .catch(error => {
      // tslint:disable-next-line:no-console
      console.log(error);
      throw error;
    });
}

export function getJson(url: string): Promise<any> {
  let urlToUse = appendGetParams(url, { ajax: true });
  const isExternalRequest = url.startsWith('http://') || url.startsWith('https://');
  const context: any = getServerSideContext();
  const headers: any = getRequestHeaders();
  if (context != null && !isExternalRequest) {
    headers.Cookie = makeCookieString(context.backend.server_side_rendering_data.cookies);
    urlToUse = context.backend.response.base_url + url;
  }
  urlToUse = urlToUse.split('#')[0];
  return axios
    .get(urlToUse, { headers })
    .then((response: any) => {
      // Handle redirecting to a non-BAA page
      if (response.data.redirect_to) {
        window.location = response.data.redirect_to;
        return {};
      }
      if (response.headers['content-type'].includes('text/html')) {
        if (urlToUse !== response.request.responseURL) {
          window.location = response.request.responseURL;
          return {};
        }
      }
      // Handle redirecting to a BAA page
      if (response.data.response && urlToUse !== response.data.response.request_path) {
        return {
          ...response.data,
          $redirected: {
            to: response.data.response.request_path,
            from: urlToUse,
          },
        };
      }

      return response.data;
    })
    .catch(error => {
      // tslint:disable-next-line:no-console
      console.log(error);
      throw error;
    });
}

export function makeCookieString(cookies: any): string {
  return Object.keys(cookies)
    .map(k => `${k}=${cookies[k]}`)
    .join('; ');
}
